// Horizontal padding of the Account shell's content area (MUI spacing units).
// Full-width pages such as the cases list cancel it with an equal negative margin.
export const ACCOUNT_CONTENT_PADDING_X = { xs: 2, md: 4 } as const;
